import { useLocation } from "react-router-dom";

export default function useCanGoBack() {
  const location = useLocation();
  return location.key !== "default";
}
